import { create } from 'zustand'
import { inventoryStorageLocType, StoredActivityType } from 'types/event/events'
import { Photo } from 'types/globalTypes'

const classesCreationStore = (set: any) => ({
  stepCounter: 0,
  setStepCounter: (state: number) => set(() => ({ stepCounter: state })),

  selectedDate: undefined,
  setSelectedDate: (state: Date) => set(() => ({ selectedDate: state })),

  activity: undefined,
  setActivity: (state: StoredActivityType) => set(() => ({ activity: state })),

  customActivity: undefined,
  setCustomActivity: (state: any) => set(() => ({ customActivity: state })),

  storageLocation: null,
  setStorageLocation: (state: inventoryStorageLocType) =>
    set(() => ({ storageLocation: state })),
  duplicateModalOpen: false,
  setDuplicateModalOpen: (state: boolean) =>
    set(() => ({ duplicateModalOpen: state })),

  classesData: null,
  setClassesData: (state: any) => set(() => ({ classesData: state })),
  requiredDetails: null,
  setRequiredDetails: (state: any) => set(() => ({ requiredDetails: state })),
  step3Payload: {
    numOfStaff: 1,
    estimatedUnitStaffSalary: { min: 0, max: 0 },
    totalStaffSalary: { min: 0, max: 0 },
    venuePrice: { min: 0, max: 0 },
    estimatedTotalPrice: { min: 0, max: 0 },
    estimatedAvgTicketPrice: { min: 0, max: 0 },
  },

  setStep3Payload: (state: any) =>
    set((currentState: any) => ({
      step3Payload: { ...currentState.step3Payload, ...state },
    })),

  step5Payload: {},
  setStep5Payload: (state: any) =>
    set(() => ({ step5Payload: state })),


  riskLevel: undefined,
  setRiskLevel: (state: 'low' | 'medium' | 'high') =>
    set(() => ({ riskLevel: state })),

  donationData: {
    allowDonation: false,
    preSelectedDonationAmounts: [],
  },
  setDonationData: (state: {
    allowDonation: boolean
    preSelectedDonationAmounts: number[]
  }) =>
    set(() => ({
      donationData: state,
    })),

  //step7
  agreements: [],
  setAgreements: (state: string[]) => set(() => ({ agreements: state })),
  emailTemplates: [],
  setEmailTemplates: (state: any[]) => set(() => ({ emailTemplates: state })),
  classRequiredDetails: {
    parentRequiredDetails: [],
    authorizedAdultRequiredDetails: [],
    kidRequiredDetails: [],
  },
  setClassRequiredDetails: (state: any) => set(() => ({ classRequiredDetails: state })),
  itemsToBring: [],
  setItemsToBring: (state: string[]) => set(() => ({ itemsToBring: state })),
  selectedFaqIds: [],
  setSelectedFaqIds: (state: string[]) =>
    set(() => ({ selectedFaqIds: state })),
  selectedRequiredDocumentIds: [],
  setSelectedRequiredDocumentIds: (state: string[]) =>
    set(() => ({ selectedRequiredDocumentIds: state })),

  // step 6
  documentsApprovalRequired: false,
  setDocumentsApprovalRequired: (state: boolean) =>
    set(() => ({ documentsApprovalRequired: state })),
  coverPhotoIds: [],
  setCoverPhotoIds: (state: string[]) => set(() => ({ coverPhotoIds: state })),
  coverPhotos: [],
  setCoverPhotos: (state: Photo[]) => set(() => ({ coverPhotos: state })),
  description: undefined,
  setDescription: (state: string) => set(() => ({ description: state })),

  // step 5 cost estimation
  feeModal: false,
  setFeeModal: (state: boolean) => set(() => ({ feeModal: state })),
  additionalFeeData: undefined,
  setAdditionalFeeData: (state: any) =>
    set(() => ({ additionalFeeData: state })),
})

export const classesEventStore = create(classesCreationStore)
